<template>
  <div class="h-dvh flex flex-col overflow-auto bg-pitch-black text-total-white">
    <!-- Header Section -->
    <TopNavbar />
    <div
      class="flex-1 overflow-y-auto pb-[40px] transition-opacity"
      :class="{ 'opacity-50': loading }"
    >
      <div class="flex w-full justify-between items-center px-4 py-4 bg-pitch-black">
        <a
          @click="goBack"
          class="text-prime-golden cursor-pointer text-lg font-medium font-avenir flex items-center"
        >
          <img
            class="w-6 h-6 inline mr-2"
            src="@/assets/images/left-chevron.svg"
            alt="Back"
          />
        </a>
        <span class="font-semibold text-2xl mr-4">Create Alarm</span>
        <span></span>
      </div>

      <!-- DATE PICKER -->
      <div class="mb-4 px-4">
        <label class="flex justify-start text-sm font-medium mb-1" for="alarmDate">
          Alarm Date (MM/DD/YYYY) *
        </label>
        <VueDatePicker
          v-model="alarmDate"
          @change="handleDateChange"
          :enable-time-picker="false"
          aria-placeholder="MM/DD/YYYY"
          dark
          class="w-full p-1 rounded-lg bg-dark-grey text-total-white focus:outline-none focus:border-prime-golden"
        />
        <div v-if="errors?.alarmDate" class="text-deep-rust text-sm text-left mt-1">
          {{ errors.alarmDate }}
        </div>
      </div>

      <!-- Create Button -->
      <div class="px-4 mt-12 my-6">
        <button
          @click="createAlarm"
          class="w-fit py-1 px-5 rounded-lg text-sm font-semibold bg-total-white-300 text-prime-golden"
          :disabled="loading"
        >
          Create
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/TopNavbar.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ref } from "vue";
import { useSimulationStore } from "@/stores/simulation";
import { useToast } from "vue-toastification";

export default {
  components: {
    TopNavbar,
    VueDatePicker,
  },
  data() {
    return {
      alarmDate: "", // Expected to be in "MM/DD/YYYY" format
      errors: {},
      loading: false,
    };
  },
  methods: {
    handleDateChange(date) {
      // Date is provided in "MM/DD/YYYY" format by the picker.
      this.alarmDate = date;
      // Clear any previous errors once a valid date is selected.
      this.errors.alarmDate = "";
    },
    formatDateToYYYYMMDD(dateString) {
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    goBack() {
      this.$router.go(-1);
    },
    async createAlarm() {
      if (!this.alarmDate) {
        this.errors.alarmDate = "Please select a valid date.";
        return;
      }
      this.loading = true;
      const simulationStore = useSimulationStore();
      const toast = useToast();

      // Format the date into YYYY-MM-DD (without time)
      const formattedDate = this.formatDateToYYYYMMDD(this.alarmDate);
      const alarmData = {
        alarm_datetime: formattedDate,
      };

      try {
        await simulationStore.createAlarm(this.$route.params.id, alarmData);
        toast.success("Alarm created successfully");
        this.$router.push({
          name: "ProjectAlarmsPage",
          params: { id: this.$route.params.id },
          query: { projectName: this.$route.query.projectName },
        });
      } catch (error) {
        toast.error("Error creating alarm");
        console.error("Error creating alarm:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Add any custom styles if needed */
</style>
